import NumberFormat from 'react-number-format';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import _ from 'lodash';
import { isTruthyAutoshipFlag } from '@Components/Common/commonMethods';

const Product = ({ smartShipCheck, minCartAutoshipCheck, Cart, deleteproduct, index, register, Add, Sub, updateqty, setcosttype, costtype, swithtoautoship, amountCalculations, setAmountCalculations, setcoupon }) => {
  //check product is selected to autoship or normal
  const qty = +Cart?.quantity || 1;
  const isSelectedSmartShip = isTruthyAutoshipFlag(Cart?.is_autoship);
  const isSmartShipPrice = isTruthyAutoshipFlag(minCartAutoshipCheck) || isTruthyAutoshipFlag(smartShipCheck) || isSelectedSmartShip;
  const displayCostPrice = (isSelectedSmartShip || isSmartShipPrice)
    ? Cart?.product?.autoship_cost_price
    : Cart?.product?.cost_price;
  const hasPromotion = Cart?.applied_promotion != null;
  const promotionalAutoshipPrice = Cart?.product?.promotional_autoship_price;
  const hasAutoshipPromotion = promotionalAutoshipPrice != null && promotionalAutoshipPrice !== "";
  const promoPrice = Cart?.line_total != null ? Cart.line_total : (Cart?.unit_price * qty);
  const originalPrice = Cart?.original_line_total != null
    ? Cart.original_line_total
    : (Cart?.original_unit_price != null ? Cart.original_unit_price * qty : displayCostPrice * qty);
  const formatPrice = (amount) => `$${parseFloat(amount).toFixed(2)} USD`;

  const renderProductPrice = () => {
    if (isSelectedSmartShip && hasAutoshipPromotion) {
      return (
        <div>
          <div className="price-afterdiscount">
            {formatPrice(promotionalAutoshipPrice * qty)}
          </div>
          <div className="price-beforediscount">
            {formatPrice(Cart?.product?.autoship_cost_price * qty)}
          </div>
          <div className="smartship-label">SmartShip</div>
        </div>
      );
    }

    if (Cart?.product?.discount_combination === true && Cart?.product?.discountAmount !== null) {
      return (
        <NumberFormat value={`${parseFloat(Cart?.product?.cost_price * qty).toFixed(2)}`}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'$'}
          renderText={value => <div>{
            !isSelectedSmartShip && !isSmartShipPrice ? (<>
              <div className="price-afterdiscount">{parseFloat(Cart?.product?.afterDiscoutAmount).toFixed(2) + " " + "USD"} </div>/
              <div className="price-beforediscount">{parseFloat(Cart?.product?.beforeDiscoutAmount).toFixed(2) + " " + "USD"}</div>
            </>) : (
              <>
                <div className="price-afterdiscount">
                  {`$${parseFloat(Cart?.product?.autoship_afterDiscoutAmount).toFixed(2)} USD`}
                </div>
                {!isSelectedSmartShip && (
                  <div className="price-beforediscount">
                    {`$${parseFloat(Cart?.product?.autoship_beforeDiscoutAmount).toFixed(2)} USD`}
                  </div>
                )}
                {Cart?.is_autoship && (
                  <div className="smartship-label">SmartShip</div>
                )}
              </>
            )}
          </div>} />
      );
    }

    if (hasPromotion && !isSelectedSmartShip) {
      return (
        <div>
          <div className="price-afterdiscount">
            {formatPrice(promoPrice)}
          </div>
          <div className="price-beforediscount">
            {formatPrice(originalPrice)}
          </div>
        </div>
      );
    }

    return (
      <>
        <NumberFormat value={`${parseFloat(displayCostPrice * qty).toFixed(2)}`}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'$'}
          renderText={value => <div>{value + " USD"}</div>}
        />
        {isSelectedSmartShip && <div className="smartship-label">SmartShip</div>}
      </>
    );
  };

  return (
    <>
      <div className="mini-cart" key={index} style={Cart?.extraProduct ? {
        background: "#fff",
        border: 'none',
      } : {}}>
        {(Cart?.extraProduct || Cart?.promo_fake_product) &&
          <div className='free_product_title'>
            <p>Your Free Product!</p>
          </div>
        }
        <div className="min-cat-uppper">

          <div className="cart-image">
            {Cart?.product?.main_image
              ?
              <img src={`${process.env.API_URL}${Cart?.product.main_image}`} />
              :
              <img src="/images/no-image.jpg" />
            }
          </div>
          <div className="mini-cart-des">
            <div className="cart-product-details">
              {Cart?.product?.name}
            </div>
            {(!Cart?.extraProduct && !Cart?.promo_fake_product) ?
              <div className="main-qty-sec">
                <div className="box">
                  {Cart?.qty_display &&
                    <div id="qty">
                      <button type="button"
                        name={`${Cart?.product?.id},${null}`}
                        disabled={Cart?.quantity === "1"}
                        id={Cart?.product?.id}
                        className="sub"
                        value={+Cart?.quantity}
                        onClick={(e) => { Sub(e, Cart?.id) }}>-</button>
                      <input
                        name={`${Cart?.product?.id},${null}`}
                        type="text"
                        readOnly
                        ref={register &&
                          register({
                            valueAsNumber: true,
                          })
                        }
                        value={+Cart?.quantity}
                      />
                      <button type="button"
                        name={`${Cart?.product?.id},${null}`}
                        id={Cart?.product?.id} data-value={Cart?.product?.quantity}
                        className="add"
                        value={+Cart?.quantity}
                        onClick={(e) => { Add(e, Cart?.id) }}>+</button>
                    </div>
                  }
                </div>
              </div>
              :
              <div style={{
                width: "100%",
                maxWidth: "112px",
                textAlign: "center",
              }}>
                <input
                  name={`${Cart?.product?.id},${null}`}
                  type="text"
                  style={{
                    width: "40px",
                    background: "#fff",
                    border: "1px solid var(--blue)",
                    textAlign: "center",
                    padding: "7.5px"
                  }}
                  readOnly
                  ref={
                    register({ valueAsNumber: true })
                  }
                  value={+Cart?.quantity}
                />
              </div>
            }
            <div className="cart-product-details">
              <p className="title">
                {renderProductPrice()}
              </p>
            </div>
            {(!Cart?.extraProduct && !Cart?.promo_fake_product) &&
              <div className="cart-product-details">
                <div className="box">
                  {(Cart?.product?.product_type === "Product" || Cart?.product?.product_type === "Bogo") &&
                    <div className="select">
                      <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example"
                        value={Cart?.is_autoship ? "AutoShip" : "Normal"}
                        data-product-id={Cart?.product?.id}
                        data-product-qty={Cart?.quantity}
                        data-variant-id={null}
                        onChange={(e) => {
                          const found = costtype.data.some(el => el.id === Cart?.product?.id);
                          if (!found) {
                            setcosttype({ ...costtype, data: [...costtype.data, { "id": Cart?.product?.id, "cartId": Cart?.id, "value": e.target.value, "variant_id": null }] })

                          }
                          else {
                            const objIndex = costtype.data.findIndex((obj => obj.id == Cart?.product?.id));
                            costtype.data.splice(objIndex, 1);

                            setcosttype({ ...costtype, data: [...costtype.data, { "id": Cart?.product?.id, "cartId": Cart?.id, "value": e.target.value, "variant_id": null }] })
                          }
                          swithtoautoship(e, Cart?.id)
                          setAmountCalculations();
                          setcoupon()
                        }}
                      >
                        <option value="Normal" >One-time Only</option>
                        <option value="AutoShip">SmartShip</option>
                        {/* <option value="AutoShip">AutoShip</option> */}

                      </select>
                    </div>
                  }
                </div>
              </div>
            }

          </div>
        </div>

        <div className="cart-product-qty-del">
          {(!Cart?.extraProduct && !Cart?.promo_fake_product) &&
            <button><DeleteOutlineIcon id={Cart?.product?.id} data-value={Cart?.variant?.id} onClick={(e) => { deleteproduct(e, Cart?.id, Cart?.is_autoship) }} className="dlt" /></button>
          }
        </div>

      </div >
    </>)
}
export default Product;
